(ns manage.adset-decision-tree-page.view.side-panel.feed.converter
  (:require [manage.adset-decision-tree-page.schema-urn :as schema-urn]))

(def macro-input-from
  {:from {:schema schema-urn/dsp-signal
          :urn schema-urn/dsp-signal
          :alias "dsp-signal"
          :param [{:dsp-macro ""}]}
   :to ""})

(def exact-match-from
  {:from {:schema schema-urn/exact-value
          :selector "value"
          :urn schema-urn/exact-value
          :alias "exact-value"
          :param {:value ""}}
   :to ""})

(def location-from
  {:from {:schema schema-urn/location
          :selector ""
          :urn schema-urn/location
          :alias "location"
          :param nil}
   :to ""})

(defn get-feed-input-type [{{:keys [schema]} :from}]
  (condp = schema
    schema-urn/dsp-signal "macro"
    schema-urn/location "macro"
    schema-urn/exact-value "exact-match"
    "exact-match"))

(defn- location-selector? [s]
  (contains? #{"city" "country" "postal-code" "region" "timezone"} s))

(defn be->input-entries [be-input-entries]
  (mapv
   (fn [be-input-entry]
     (update be-input-entry :from
             (fn [from-data]
               (let [selector (:selector from-data)]
                 (cond
                   (location-selector? selector)
                   (-> from-data
                       (assoc :param [{:dsp-macro selector}]))

                   ;; Currently data conversion is only needed for Location input
                   :else from-data)))))
   be-input-entries))

(defn ->form [value]
  (if (empty? value)
    [{:param {:data {:in [exact-match-from]}}}]
    (update-in value [0 :param :data :in] be->input-entries)))

(defn input-entries->be [feed-input-entries]
  (mapv
   (fn [feed-input-entry]
     (update feed-input-entry :from
             (fn [from-data]
               (let [dsp-macro (get-in from-data [:param 0 :dsp-macro])]
                 (cond
                   (location-selector? dsp-macro)
                   (-> (:from location-from)
                       (assoc :selector dsp-macro))

                   (seq dsp-macro)
                   ;; get macro-name out of dsp-macro in format "${macro-name}" by removing "${" and "}"
                   (let [macro-name (subs dsp-macro 2 (- (count dsp-macro) 1))]
                     (-> (:from macro-input-from)
                         (merge from-data)
                         (assoc-in [:selector] macro-name)
                         (assoc-in [:param 0 :name] macro-name)))

                   ;; Currently data conversion is only needed for Macro and Location input
                   :else (merge (:from exact-match-from) from-data))))))
   (or (seq feed-input-entries) [{}])))

(defn <-form [[value]]
  [(-> {:schema schema-urn/feed :alias "feed"}
       (merge value)
       (update-in [:param :data :in] input-entries->be))])

(def non-empty-string [:string {:min 1 :error/message ""}])

(def schema
  [:sequential
   [:map {:error/message ""}
    [:param [:map {:error/message ""}
             [:feed-id [:int {:error/message ""}]]
             [:data [:map
                     [:in [:sequential
                           [:map {:error/message ""}
                            [:from [:map
                                    [:param
                                     [:or
                                      [:sequential
                                       ;; without `:error/path` the error for the other branch
                                       ;; of `:or` won't be returned by `me/humanize`,
                                       ;; having the consequence of no error on the UI
                                       {:error/path [:sequential-error]}
                                       [:map {:error/message ""}
                                        [:dsp-macro non-empty-string]]]
                                      [:map {:error/message ""}
                                       [:value non-empty-string]]
                                      nil?]]]]
                            [:to non-empty-string]]]]]]]]
    [:value-column non-empty-string]]])
